import { Type } from 'class-transformer';
import { User } from '@core/model/user.model';

export class AuditMetadata {
  @Type(() => User) createdBy!: User
  @Type(() => Date) createdOn!: Date
  @Type(() => User) updatedBy!: User
  @Type(() => Date) updatedOn?: Date
}
